import { render, staticRenderFns } from "./covid-19-popup.html?vue&type=template&id=3d163107&scoped=true&external"
import script from "./covid-19-popup.js?vue&type=script&lang=js&external"
export * from "./covid-19-popup.js?vue&type=script&lang=js&external"
import style0 from "./covid-19-popup.scss?vue&type=style&index=0&id=3d163107&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d163107",
  null
  
)

export default component.exports